import { Component, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Multitenant } from '../../../services/multitenant.provider';
import { AuthProvider } from '../../../services/auth.provider';
import { MetaProvider } from '../../../services/meta.provider';
import { PopUp } from '../../../models/popup.model';
import { PopUpService } from '../../../shared/components/pop-up/pop-up.service';
import { IonHeader } from '@ionic/angular';

@Component({
  selector: 'app-archives-newspapers',
  templateUrl: 'archives-newspapers.html',
  styleUrls: ['archives-newspapers.scss']
})
export class ArchivesNewspapersPage {
  @ViewChild(IonHeader) header: IonHeader;

  public themeClass: string;
  public authenticated: boolean;
  public newspapers: Array<any>;
  public isActivePage: string;
  public tempPopUp: boolean;
  public popup: PopUp = new PopUp();
  public currentPosition = window.scrollY;

  constructor(
    private router: Router,
    private multiTenant: Multitenant,
    private auth: AuthProvider,
    private meta: MetaProvider,
    private popUpService: PopUpService,
    public renderer: Renderer2
  ) { }

  ionViewWillEnter() {
    let news: Array<any>;
    const newspapers: Array<any> = [];
    this.themeClass = this.multiTenant.getDomainClass();
    this.authenticated = this.auth.isAuthenticated();

    if (this.auth.isAuthenticated() && this.auth.hasAccessToPrint()) {
      news = this.auth.hasAccessToPrint().split(',');
    }

    if (this.auth.isAuthenticated() && this.auth.hasAccessToPdf()) {
      news = news || [];
      const newsAccPdf = this.auth.hasAccessToPdf().split(',');
      news = [...new Set([...news, ...newsAccPdf])];
    }

    if (this.auth.hasAccessTo() && this.auth.isAuthenticated()) {
      news = news || [];
      const newsAccess = this.auth.hasAccessTo().split(',');
      news = [...new Set([...news, ...newsAccess])];
    }

    if (!this.auth.isAuthenticated()) {
      news = ['lepq', 'mquo', 'actu', 'aeco'];
    }

    news.forEach( (item, index) => {
      if (item === 'lepq') {
        newspapers.push({ class: 'lepq', age: 'Pour les 7-10 ans' });
      }
      if (item === 'mquo') {
        newspapers.push({ class: 'mquo', age: 'Pour les 10-13 ans' });
      }
      if (item === 'actu') {
        newspapers.push({ class: 'actu', age: 'Pour les 13-20 ans' });
      }
      if (item === 'aeco') {
        newspapers.push({ class: 'aeco', age: 'Pour les 15-20 ans' });
      }
      if (item === 'week') {
        newspapers.push({ class: 'week', age: '' });
      }
      if (item === 'mwne') {
        newspapers.push({ class: 'mwne', age: '' });
      }
      if (item === 'mwjp') {
        newspapers.push({ class: 'week', age: '' });
      }
      if (item === 'clfy') {
        newspapers.push({ class: 'week', age: '' });
      }
      if (item === 'mlwk') {
        newspapers.push({ class: 'mlwk', age: '' });
      }
      if (item === 'mlne') {
        newspapers.push({ class: 'mlne', age: '' });
      }
      if (item === 'woch') {
        newspapers.push({ class: 'woch', age: '' });
      }
      if (item === 'sema') {
        newspapers.push({ class: 'sema', age: '' });
      }
    });

    this.newspapers = newspapers;

    if (this.newspapers.length === 1) {
      this.router.navigate(['pdf', this.newspapers[0].class]);
    }

    this.renderer.setStyle(this.header['el'], 'webkitTransition', 'margin-top 700ms');
  }

  ionViewDidEnter() {
    if (this.auth.logedWithNoProfiles()) {
      this.router.navigate(['creer-compte', 'etape-2']);
    } else if (this.auth.isPartiallyAuthenticated()) {
      this.router.navigate(['profiles']);
    }
    this.isActivePage = 'archives';
    this.meta.clearHead();

    if (!this.auth.isAuthenticated() && this.popUpService.havePassedSevenDays() && this.multiTenant.getDomainClass() === 'playbacpresse') {
      this.tempPopUp = true;
      this.popup.type = 'unIdentifiedUser';
    }
  }

  goToArchives(newspaper) {
    this.router.navigate(['pdf', newspaper]);
  }

  public onContentScroll(event:any) {
    let scroll = event.detail.scrollTop;
    if (scroll > 10 && scroll > this.currentPosition) {
      this.renderer.setStyle(this.header['el'], 'margin-top', this.authenticated ?  '-76px' : '-60px');
    } else {
      this.renderer.setStyle(this.header['el'], 'margin-top', '0px');
    }

    this.currentPosition = scroll;
  }
}
